import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { Button, Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

import PATH from "../../routes/RoutePath";
import QUERY from "../../utils/service/query";

const EditMyAccount = () => {
  const { data } = useQuery(QUERY.ACCOUNT.GET_MY_ACCOUNT);
  const [updateMyAccount, { error }] = useMutation(
    QUERY.ACCOUNT.EDIT_MY_ACCOUNT,
  );

  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(
    data?.getAdminProfile?.userProfile?.firstName || "",
  );
  const [lastName, setLastName] = useState(
    data?.getAdminProfile?.userProfile?.lastName || "",
  );
  const [email, setEmail] = useState(data?.getAdminProfile?.email || "");

  useEffect(() => {
    setFirstName(data?.getAdminProfile?.userProfile?.firstName);
    setLastName(data?.getAdminProfile?.userProfile?.lastName);
    setEmail(data?.getAdminProfile?.email);
  }, [data]);

  return (
    <Card className="">
      <Card.Header>
        <h5>Edit My Account</h5>
      </Card.Header>
      <Card.Body className="bg-light">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            updateMyAccount({
              refetchQueries: [QUERY.ACCOUNT.GET_MY_ACCOUNT],
              variables: {
                firstName: firstName,
                lastName: lastName,
                email: email,
              },
            })
              .then(() => {
                toast.success("Changes saved successfully");
                navigate(PATH.ACCOUNT.MY_ACCOUNT);
              })
              .catch(() => {
                toast.error("Something went wrong!");
              });
          }}>
          <Form.Group className="mb-3">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              placeholder={"First Name"}
              value={firstName}
              name="firstName"
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              placeholder={"Last Name"}
              value={lastName}
              name="lastName"
              onChange={(e) => {
                setLastName(e.target.value);
              }}
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              placeholder={"Email address"}
              value={email}
              name="email"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              type="email"
            />
            <span style={{ fontSize: "0.875rem", color: "#e83c4a" }}>
              {error?.message || ""}
            </span>
          </Form.Group>
          <Button
            type="submit"
            disabled={
              data?.getAdminProfile?.userProfile?.firstName === firstName &&
              data?.getAdminProfile?.userProfile?.lastName === lastName &&
              data?.getAdminProfile?.email === email
            }>
            SAVE
          </Button>{" "}
          <Link to={PATH.ACCOUNT.MY_ACCOUNT}>
            <Button variant="outline-danger">CANCEL</Button>
          </Link>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default EditMyAccount;
